exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html body{height:100vh;overflow:hidden;position:relative;top:0;left:0}.ui.modal .content{padding:5px}.errormessage{position:relative}.errormessage .contenterror{padding:3rem}.errormessage .contenterror .content-image{text-align:center}.errormessage .contenterror .content-image img{display:inline-block}.errormessage .contenterror .content-text{text-align:center}.errormessage .contenterror .content-text p{font-size:26px}.errormessage .close{position:absolute;cursor:pointer;top:0;right:0;padding:5px}.errormessage .close img{display:inline-block;width:25px;height:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/modalErrorMessageDialog.scss
// module id = 569
// module chunks = 2